import { Injectable, OnDestroy } from '@angular/core';

import { MessageEnvelope } from '@cds/push';
import { Store } from '@ngrx/store';

import BetslipPickSubscriptionService from '../../picks/services/betslip-pick-subscription.service';
import { SubscriptionCallBacksPool } from '../../picks/services/subscription-call-backs.pool';
import { BetslipTeaserCdsActions } from '../teaser-bet-cds.actions';

class TeaserPickSubscriptionCallBacksPool extends SubscriptionCallBacksPool {
    constructor(store: Store) {
        super(store);
    }

    override eventUpdated = (message: MessageEnvelope) => {
        this.store.dispatch(BetslipTeaserCdsActions.eventUpdate({ payload: message }));
    };
}

@Injectable()
export class TeaserBetPickSubscriptionService extends BetslipPickSubscriptionService implements OnDestroy {
    override subscriptionsCallbacksPool: SubscriptionCallBacksPool = new TeaserPickSubscriptionCallBacksPool(this.store);
}
